import { render, staticRenderFns } from "./CourseProgression.vue?vue&type=template&id=142a75b3&scoped=true"
import script from "./CourseProgression.vue?vue&type=script&lang=ts"
export * from "./CourseProgression.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a75b3",
  null
  
)

export default component.exports